import mainService from 'services/mainService';

export function transitGetSweptPath(portId: number, transitsIds: { id: number[] }) {
    return mainService
        .post(`transits/${portId}/swept`, transitsIds)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitUpdate(portId: number, data: object) {
    return mainService
        .patch(`transits/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transistFullDataTransist(portId: number, mode: string,updates: string[], transists: number[]) {
    return mainService
        .post(`transits/${portId}/fullData`, {
            mode,
            updates,
            id: transists,
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitExport(portId: number, id: number | string) {
    return mainService
        .get(`transits/${id}/export`, { responseType: 'blob' })
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitDownloadSweptPath(portId: number, id: number | string) {
    return mainService
        .get(`transits/${portId}/${id}/downloadSwept`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitUpdateTags(portId: number, id: number | string, data: object) {
    return mainService
        .patch(`transits/${id}/tags/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitExportAll(portId: number, transits, id, retry) {
    return mainService
        .post(`transits/${portId}/exportAll`, { transits, id, retry })
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitGetTags(portId: number, id: number | string) {
    return mainService
        .get(`transits/${id}/tags`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitGetComments(portId: number, id: number | string) {
    return mainService
        .get(`transits/${id}/comments`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
export function transitCreateComment(portId: number, id: number | string, data: object) {
    return mainService
        .post(`transits/${id}/comments/create`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
export function transitUpdateComment(portId: number, id: number | string, data: object) {
    return mainService
        .put(`comments/${portId}/${id}/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function transitDeleteComment(portId: number, id: number | string) {
    return mainService
        .delete(`comments/${portId}/${id}/delete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function offsetByVisit(portId: number, visitId) {
    return mainService
        .get(`transits/${visitId}/offsetByVisit`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function updateTransit(portId: number, id: number | string, data: any) {
    return mainService
        .put(`transits/${id}/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
